import * as React from "react";
// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import RangedDatePickerController from "./RangedDatePickerController";

import DatePicker from "react-datepicker";

import "./RangedDatePicker.scss";
import {DateRangePicker} from "@vebox/etui-core";
import moment = require("moment-timezone");

export interface RangedDatePickerProps {
    controller: RangedDatePickerController;
    maxInterval?: number;
    fromLabel?: any;
    toLabel?: any;
    minDate?: Date;
    maxDate?: Date;
    dateFormat?: string;
    locale?: string;
    showBoth?: boolean;
    disabled?: boolean;
    disableKeyboardNavigation?: boolean;
    useETUIcomponent?: boolean;
}

export interface RangedDatePickerState {
    startDate: Date;
    endDate: Date;
}

export default class RangedDatePicker extends React.Component<RangedDatePickerProps, RangedDatePickerState> {

    private listenerSubscription: Subscription;

    constructor(props: RangedDatePickerProps) {
        super(props);
        this.state = {
            startDate: this.props.controller.startDate ?? undefined,
            endDate: this.props.controller.endDate ?? undefined,
        };
    }

    public componentDidMount() {
        this.listenerSubscription = this.props.controller.listen(({start, end}) => {
            this.setState({
                startDate: start,
                endDate: end,
            });
        });
    }

    public componentWillUnmount() {
        if (this.listenerSubscription) {
            this.listenerSubscription.unsubscribe();
        }
    }

    public render() {
        const ETUIpicker = (
            <div
                className={"etui-date-range-picker"}
            >
                <DateRangePicker
                    label={`${this.props.fromLabel} - ${this.props.toLabel}`}
                    onChange={// tslint:disable-next-line:jsx-no-lambda
                        (p) => {
                            this.dateChangedEtui(p);
                        }}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    styles={{
                        input: {
                            pb: "0",
                            pt: "10px",
                            width: "unset",
                            height: "38px",
                            bg: "var(--second-level-tabbar-button-bg)",
                            color: "var(--second-level-tabbar-active-text-color)",
                            borderColor: "var(--tabbar-text-color-active)",
                        },
                        inputLabel: {
                            color: "var(--tabbar-text-color-active)",
                            textTransform: "uppercase"
                        }
                    }}
                    /*
                    * ↓ Il formato della data è settato in maniera sbagliata,
                    * è un fix provvisorio in attesa del fix del componente ETUI
                    * */
                    dateFormat={this.props.dateFormat === "MM/dd/yyyy" ? "MM/DD/YYYY" : "DD/MM/YYYY"}
                    /*dateFormat={this.props.dateFormat}
                    * TODO [ETUI] implementare il dateformat quando il componente ETUI sarà stato cambiato
                    * */
                />
            </div>
        );

        const startPicker = (
            <div className="start-date-ranged-date-picker">
                {this.props.fromLabel}
                <div className={"date-picker-element"}>
                    <DatePicker
                        selected={this.state.startDate}
                        onChange={this.startChanged}
                        minDate={this.props.minDate}
                        maxDate={this.props.maxDate}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        dateFormat={this.props.dateFormat}
                        // locale={this.props.locale}
                        selectsStart={true}
                        disabled={this.props.disabled}
                    />
                </div>
            </div>
        );

        let maxDate = null;
        if (this.props.maxInterval) {
            maxDate = new Date(this.state.startDate);
            maxDate.setDate(maxDate.getDate() + (this.props.maxInterval - 1));
        }
        const endPicker = (
            <div className="end-date-ranged-date-picker">
                {this.props.toLabel}
                <div className="date-picker-element">
                    <DatePicker
                        selected={this.state.endDate}
                        selectsEnd={true}
                        onChange={this.endChanged}
                        minDate={this.state.startDate}
                        maxDate={this.minDate(maxDate, this.props.maxDate)}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        dateFormat={this.props.dateFormat}
                        // locale={this.props.locale}
                        disabled={this.props.disabled}
                    />
                </div>
            </div>
        );

        return (
            this.props.useETUIcomponent ?
                <> {ETUIpicker} </> :
                <>
                    {startPicker}
                    {(this.state.startDate || this.props.showBoth)
                    && (!this.props.disabled || this.state.endDate) ? endPicker : ""}
                </>
        );
    }

    private minDate = (A: Date, B: Date): Date => {
        if (!A && !B) {
            return null;
        }
        if (!A || !B) {
            return A ? A : B;
        }
        return new Date(Math.min(A.getTime(), B.getTime()));
    }

    private startChanged = (newStartingDate: Date) => {
        if (
            (this.props.maxDate && (newStartingDate.getTime() > this.props.maxDate.getTime()))
            || (this.props.minDate && (newStartingDate.getTime() < this.props.minDate.getTime()))
        ) {
            return;
        }

        let newEndDate = this.state.endDate;
        if (this.state.endDate) {
            const endSinceEpoch = this.state.endDate.getTime();
            const startSinceEpoch = newStartingDate.getTime();
            const timeDifference = endSinceEpoch - startSinceEpoch;
            if (timeDifference > (this.props.maxInterval - 1) * 24 * 3600 * 1000) {
                newEndDate = new Date(newStartingDate);
                newEndDate.setDate(newEndDate.getDate() + (this.props.maxInterval - 1));
            } else if (timeDifference < 0) {
                newEndDate = new Date(newStartingDate);
            }
        }

        this.props.controller.changeRange(newStartingDate, newEndDate);
        this.setState({
            startDate: newStartingDate,
            endDate: newEndDate,
        });
    }

    private endChanged = (newEndingDate: Date) => {
        if (
            (this.props.maxDate && (newEndingDate.getTime() > this.props.maxDate.getTime()))
            || (this.props.minDate && (newEndingDate.getTime() < this.props.minDate.getTime()))
        ) {
            return;
        }
        this.props.controller.changeRange(this.state.startDate, newEndingDate);
        this.setState({
            endDate: newEndingDate,
        });
    }

    private dateChangedEtui = (p) => {
        if ((!p.startDate && !p.endDate)) {
            p.startDate = moment().startOf("day").toDate();
            p.endDate = moment().endOf("day").toDate();
        }

        if (!p.startDate) {
            p.startDate = moment(p.endDate).add(-1, "day").toDate();
        }
        if (p.endDate === null) {
            p.endDate = moment(p.startDate).endOf("day").toDate();
        }

        if (p.endDate === undefined) {
            p.endDate = moment().endOf("day").toDate();
        }

        if (p.startDate.getTime() > p.endDate.getTime()) return;

        if (
            !((this.props.maxDate && (p.startDate.getTime() > moment(this.props.maxDate.getTime()).endOf("day").toDate()
                    .getTime()))
                || (this.props.minDate && (p.startDate.getTime() < this.props.minDate.getTime())))
            && !((this.props.maxDate && (p.endDate.getTime() > this.props.maxDate.getTime()))
                || (this.props.minDate && (p.endDate.getTime() < this.props.minDate.getTime())))
        ) {
            this.props.controller.changeRange(p.startDate, p.endDate);
            this.setState({
                startDate: p.startDate,
                endDate: p.endDate,
            });
        }
    }
}
